export default __webpack_public_path__ + "static/media/text-chat-dark.1e793796.svg";